const indexItems = [
  {
    title: '奇幻冒险',
    desc: '魔法与剑的史诗',
    count: '48部',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20manga%20illustration%20with%20a%20hero%20wielding%20a%20glowing%20sword%20in%20a%20magical%20forest%20with%20ancient%20ruins%20and%20floating%20crystals%20warm%20golden%20sunlight%20filtering%20through%20trees%20epic%20adventure%20vibe%20detailed%20background%20art%20vibrant%20colors&width=300&height=200&seq=index-topic-01&orientation=landscape',
  },
  {
    title: '魔幻世界',
    desc: '异世界穿越之旅',
    count: '52部',
    img: 'https://readdy.ai/api/search-image?query=Magical%20fantasy%20world%20illustration%20with%20floating%20islands%20and%20a%20grand%20castle%20in%20the%20sky%20ethereal%20mist%20and%20rainbow%20bridges%20connecting%20realms%20magical%20creatures%20flying%20around%20soft%20dreamy%20pastel%20colors%20whimsical%20atmosphere&width=300&height=200&seq=index-topic-02&orientation=landscape',
  },
  {
    title: '萌系治愈',
    desc: '温暖人心的日常',
    count: '36部',
    img: 'https://readdy.ai/api/search-image?query=Cute%20kawaii%20manga%20style%20illustration%20of%20adorable%20chibi%20characters%20enjoying%20a%20peaceful%20afternoon%20tea%20party%20in%20a%20flower%20garden%20with%20soft%20sunlight%20pastel%20pink%20and%20cream%20colors%20fluffy%20clouds%20in%20the%20sky%20gentle%20wholesome%20vibe&width=300&height=200&seq=index-topic-03&orientation=landscape',
  },
  {
    title: '热血格斗',
    desc: '燃爆全场的对决',
    count: '29部',
    img: 'https://readdy.ai/api/search-image?query=Action%20manga%20scene%20with%20two%20powerful%20fighters%20clashing%20in%20a%20dynamic%20pose%20energy%20waves%20exploding%20around%20them%20dramatic%20camera%20angle%20from%20below%20intense%20expression%20dust%20and%20debris%20flying%20vibrant%20action%20lines%20cinematic%20lighting&width=300&height=200&seq=index-topic-04&orientation=landscape',
  },
  {
    title: '悬疑推理',
    desc: '烧脑谜题层层揭开',
    count: '21部',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20scene%20in%20a%20dimly%20lit%20library%20with%20a%20detective%20character%20examining%20clues%20under%20a%20desk%20lamp%20old%20books%20and%20papers%20scattered%20around%20moody%20atmosphere%20with%20warm%20amber%20lighting%20shadows%20and%20intrigue%20detailed%20illustration&width=300&height=200&seq=index-topic-05&orientation=landscape',
  },
  {
    title: '恋爱甜宠',
    desc: '甜蜜的心动时刻',
    count: '35部',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20manga%20scene%20of%20a%20couple%20walking%20under%20cherry%20blossom%20trees%20in%20full%20bloom%20soft%20pink%20petals%20falling%20around%20them%20warm%20spring%20sunlight%20gentle%20expressions%20pastel%20color%20palette%20dreamy%20shojo%20manga%20style%20beautiful%20background&width=300&height=200&seq=index-topic-06&orientation=landscape',
  },
  {
    title: '经典完结',
    desc: '一口气看到结局',
    count: '67部',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20collection%20of%20manga%20volumes%20arranged%20on%20a%20wooden%20bookshelf%20with%20warm%20ambient%20lighting%20from%20a%20nearby%20window%20golden%20hour%20sunlight%20casting%20soft%20shadows%20cozy%20reading%20atmosphere%20vintage%20aesthetic%20with%20colorful%20book%20spines%20peaceful%20scene&width=300&height=200&seq=index-topic-07&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          专题合集
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          按题材分类浏览，快速找到您最爱的漫画类型
        </p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute top-2 right-2 px-2 py-0.5 rounded-full bg-background-50/80 text-foreground-700 text-xs">
                  {item.count}
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}